import { useForm } from 'react-hook-form';

import { useScrollTo } from '../../../../helpers';
import {
  FileTypeError,
  FileSizeError,
  sendForm
} from '../../lib';

function useSubmitForm({
  contactDefaultValues = {},
  contactInformationFields,
  defaultValues = {},
  fields,
  formName,
  scrollToRef,
  onSuccess = () => {},
  preSubmit = () => {},
  setStatus,
  setSubmissionComplete,
  setDialogOpen,
}) {

  const scrollTo = useScrollTo(scrollToRef);

  const _defaultValues = {
    ...contactDefaultValues,
    ...defaultValues,
  };

  const _fields = [
    'Form',
    ...contactInformationFields,
    ...fields,
  ];

  const {
    clearErrors,
    control,
    formState,
    handleSubmit,
    register,
    reset,
    setValue,
    unregister,
    watch,
  } = useForm({
    shouldFocusError: true,
    mode: 'onChange',
    criteriaMode: 'all',
    defaultValues: _defaultValues,
  });

  const onSubmit = (data) => {
    data.Form = formName;
    if (data.flywheel) {
      return;
    }
    preSubmit();

    scrollTo();

    setDialogOpen(true);
    setStatus('Submitting...');
    sendForm({ data, fields: _fields, endpoint: 'request-a-quote' })
      .then((response) => {
        setStatus('An email has been sent to our sales department with the details you provided. A representative will get back to you within 1 to 2 business days.');
        setSubmissionComplete(true);
        reset(defaultValues);
        clearErrors();
        onSuccess();
      })
      .catch((error) => {
        setSubmissionComplete(true);

        if (error instanceof FileTypeError) {
          setStatus(error.message);
        }
        if (error instanceof FileSizeError) {
          setStatus(error.message);
        }
        if (error instanceof TypeError) {
          setStatus('There was a network error. Please try again shortly.');
        }
        if (error instanceof Error) {
          setStatus(`There was an error saving your submission: ${error.message}`);
        }
      });

  };

  return {
    control,
    formState,
    handleSubmit,
    register,
    onSubmit,
    reset,
    unregister,
    setValue,
    watch,
  }
};

export default useSubmitForm;
